module.exports = __webpack_public_path__ + "3fb172fb49cbd8249d0feaeee964c687.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-goodshare/src/fonts/fontello.woff2?88483298
// module id = 11
// module chunks = 0